var _path, _g, _path2, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuroblastoma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20522",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 10,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H2V21H12V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75391 18.707L3.80817 17.9168C4.77202 17.1949 5.54507 16.3363 6.08724 15.3705L6.37844 14.6778C6.60937 13.4583 7.05111 12.2778 7.6736 11.1461C8.18565 10.2192 8.86839 9.74119 9.5712 8.94119C10.2238 8.20948 10.5652 7.32168 10.5853 6.42412L10.6655 3.72168",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37109 20.2687C6.25864 19.3419 7.83489 18.1712 7.83489 18.1712C8.52766 17.7126 9.14012 17.5078 10.0437 17.6346C11.4192 17.82 11.8209 17.9273 13.7084 17.7517",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20522",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 3,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3H12V21H22V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2476 18.707L20.1933 17.9168C19.2295 17.1949 18.4564 16.3363 17.9142 15.3705L17.623 14.6778C17.3921 13.4583 16.9504 12.2778 16.3279 11.1461C15.8158 10.2192 15.1331 9.74119 14.4303 8.94119C13.7777 8.20948 13.4363 7.32168 13.4162 6.42412L13.3359 3.72168",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6303 20.2687C17.7427 19.3419 16.1665 18.1712 16.1665 18.1712C15.4737 17.7126 14.8613 17.5078 13.9576 17.6346C12.5821 17.82 12.1805 17.9273 10.293 17.7517",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 15.6927C13.3206 15.6927 14.3904 14.6532 14.3904 13.3708C14.3904 12.0884 13.3206 11.0488 12.0009 11.0488C10.6812 11.0488 9.61133 12.0884 9.61133 13.3708C9.61133 14.6532 10.6812 15.6927 12.0009 15.6927Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5293 13.6348L11.5392 13.6648",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuroblastoma);
export default __webpack_public_path__ + "static/media/Neuroblastoma.499cf54784b47dabe831904c9ae00062.svg";
export { ForwardRef as ReactComponent };